export const ERROR_MESSAGES = {
    ERROR: 'ERROR',
    GENERIC_ERROR: 'Something went wrong. Please try again.',
    NETWORK_ERROR:
        'Network connection issue. Please check your internet connection and try again.',
    TIMEOUT_ERROR: 'Request timed out. Please try again.',
    SERVER_ERROR:
        "We're experiencing technical difficulties. Please try again later.",
    UNAUTHORIZED:
        'You are not authorized to perform this action. Please sign in.',
    NOT_FOUND: 'The requested resource was not found.',
    VALIDATION_ERROR: 'Please check your information and try again.'
}

export const VISA_ERRORS = {
    FETCH_VISA_REQUIREMENTS_ERROR:
        'Unable to fetch visa requirements for the selected country. Please try again.',
    CREATE_VISA_APPLICATION_ERROR:
        'Unable to create visa application. Please try again later.',
    UPDATE_VISA_APPLICATION_ERROR:
        'Unable to update visa application. Please try again later.',
    ITINERARY_CREATE_ERROR:
        'Failed to create your travel itinerary. Please try again.',
    ITINERARY_UPDATE_ERROR:
        'Failed to update your travel itinerary. Please try again.',
    PAYMENT_INITIATION_ERROR:
        'Unable to initiate payment. Please try again later.',
    FETCH_BOOKING_ERROR: 'Unable to fetch your visa booking. Please try again.',
    DOCUMENT_UPLOAD_ERROR:
        'Document upload failed. Please check your file size and format, then try again.',
    DOCUMENT_PROCESSING_ERROR:
        'We encountered an issue processing your documents. Please try again.',
    BOOKING_LIST_ERROR:
        'Unable to load your visa bookings. Please try refreshing the page.',
    PAYMENT_CONFIRMATION_ERROR:
        'Unable to confirm payment details. Please contact support.'
}

export const AUTH_ERRORS = {
    SIGN_IN_ERROR: 'Unable to sign in. Please check your email and password.',
    SIGN_UP_ERROR: 'Unable to create account. Please try again.',
    PASSWORD_RESET_ERROR: 'Unable to reset password. Please try again later.',
    SESSION_EXPIRED: 'Your session has expired. Please sign in again.',
    INVALID_CREDENTIALS: 'Invalid email or password. Please try again.',
    EMAIL_NOT_FOUND: 'Email address not found. Please check and try again.',
    EMAIL_ALREADY_EXISTS:
        'An account with this email already exists. Please sign in instead.',
    PASSWORD_MISMATCH: 'Passwords do not match. Please try again.'
}

export const getMessageForStatusCode = (statusCode: number): string => {
    switch (statusCode) {
        case 400:
            return ERROR_MESSAGES.VALIDATION_ERROR
        case 401:
            return ERROR_MESSAGES.UNAUTHORIZED
        case 403:
            return ERROR_MESSAGES.UNAUTHORIZED
        case 404:
            return ERROR_MESSAGES.NOT_FOUND
        case 408:
            return ERROR_MESSAGES.TIMEOUT_ERROR
        case 500:
        case 502:
        case 503:
        case 504:
            return ERROR_MESSAGES.SERVER_ERROR
        default:
            return ERROR_MESSAGES.GENERIC_ERROR
    }
}

export const getMessageForEndpoint = (
    url: string,
    method: string = 'GET'
): string => {
    // Visa-related endpoints
    if (url.includes('/visa/country-metadata')) {
        return VISA_ERRORS.FETCH_VISA_REQUIREMENTS_ERROR
    }
    if (url.includes('/visa/info') && method.toUpperCase() === 'POST') {
        return VISA_ERRORS.ITINERARY_CREATE_ERROR
    }
    if (url.includes('/visa/info') && method.toUpperCase() === 'PUT') {
        return VISA_ERRORS.ITINERARY_UPDATE_ERROR
    }
    if (url.includes('/visa/prepayment')) {
        return VISA_ERRORS.PAYMENT_INITIATION_ERROR
    }
    if (url.includes('/visa/bookings') && !url.includes('/bookingdetails/')) {
        return VISA_ERRORS.BOOKING_LIST_ERROR
    }
    if (url.includes('/visa/bookingdetails/')) {
        return VISA_ERRORS.FETCH_BOOKING_ERROR
    }
    if (url.includes('/visa/upload/')) {
        return VISA_ERRORS.DOCUMENT_UPLOAD_ERROR
    }
    if (url.includes('/visa/confirmation/')) {
        return VISA_ERRORS.PAYMENT_CONFIRMATION_ERROR
    }

    // Authentication-related endpoints
    if (url.includes('/signin') || url.includes('/login')) {
        return AUTH_ERRORS.SIGN_IN_ERROR
    }
    if (url.includes('/user/register')) {
        return AUTH_ERRORS.SIGN_UP_ERROR
    }
    if (url.includes('/resetPassword')) {
        return AUTH_ERRORS.PASSWORD_RESET_ERROR
    }
    if (url.includes('/people/v2/fetch')) {
        return AUTH_ERRORS.EMAIL_NOT_FOUND
    }

    // Default fallback
    return ERROR_MESSAGES.GENERIC_ERROR
} // src/constants/error/index.tsx
